import { Injectable } from '@angular/core';
import { Alert } from 'src/app/shared/model';
import { Observable, Subject } from 'rxjs';
import { AlertType } from 'src/app/shared/model/allgemein/alert-type.model';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    alerts: Array<Alert>;
    alertsSubject: Subject<Array<Alert>>;

    constructor(public snack: MatSnackBar) {
        this.alerts = new Array<Alert>();
        this.alertsSubject = new Subject<Array<Alert>>();
    }

    addAlert(alert: Alert) {
        this.alerts.push(alert);
        this.update();
    }

    createAlert(message: string, detail: string, type: string) {
        this.addAlert({
            message,
            detail,
            type: AlertType[type],
        });
    }

    removeAlert(alert: Alert) {
        const index = this.alerts.indexOf(alert);
        if (index > -1) {
            this.alerts.splice(index, 1);
            this.update();
        }
    }

    getAlerts(): Observable<Array<Alert>> {
        return this.alertsSubject.asObservable();
    }

    private update() {
        this.alertsSubject.next(this.alerts);
    }

    public showValidationError(err) {
      if(err.status != 400)
        return;
      let msg = '';
      console.log(err);
      for(let e of err.error.errors) {
        msg += e.defaultMessage + '\r\n';
      }
      this.snack.open(msg, '', {panelClass: 'danger-snackbar', });
    }

    public showCustomValidationError(err) {
      if(err.status != 422)
        return;
      this.snack.open(err.error.msg, '', {panelClass: 'danger-snackbar', });
    }
}
